// Como jogar (Perfil, seção JOGO): as regras da mesa, as mesmas do botão Regras da mesa (REGRAS).
import { voltar } from '../comum/rotas.ts';
import { REGRAS } from '../mesa/textos.ts';
import { Tela, Topo } from './comum.tsx';

export function ComoJogar() {
  return (
    <Tela>
      <Topo titulo="Como jogar" voltar={voltar} marca />
      <section className="cartao como-jogar" aria-label="Regras da mesa">
        <ul className="rules">{REGRAS.map((r, i) => <li key={i} dangerouslySetInnerHTML={{ __html: r }} />)}</ul>
      </section>
    </Tela>
  );
}
